import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@wds/badge';

const VARIANTS = {
	signed: { color: 'success', label: gettext('Signed') },
	connected: { color: 'success', label: gettext('Connected') },
	not_connected: {color: 'warning', label: gettext('Not Connected')}
};

const DocuSignBadge = ({ variant }) => {
	const { color, label } = VARIANTS[variant];
	return <Badge color={color}>{label}</Badge>;
};

DocuSignBadge.propTypes = {
	variant: PropTypes.oneOf(['signed', 'connected', 'not_connected']).isRequired,
};

export default DocuSignBadge;
